import FlagProvider from '@unleash/proxy-client-react'
import { PropsWithChildren } from 'react'
import config from '../config'

export default function FeatureTogglesProvider({ children }: PropsWithChildren<{}>) {
  return <FlagProvider config={config.unleash}>{children}</FlagProvider>
}
